import type { SVGProps } from 'react'

export const Thunder = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7158 1L7.99997 6.185H9.99997L8.67914 12.6667L17.1666 6.185L13.5 6.16691L17.1666 1H10.7158Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.70634 8.05859C5.62621 8.94493 5.00005 10.2686 4.99997 11.6659C4.99998 13.3594 5.91744 14.9199 7.39719 15.7435C8.87695 16.5671 10.6867 16.5243 12.126 15.6319C12.1704 15.6039 12.2149 15.5752 12.2593 15.5459C13.8081 14.5105 14.5928 12.6533 14.2554 10.8211"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
